// import { trackOutbound } from '../../../../../shared/analytics/outbound';
import { addShells } from '../../../../../shared/redis';
// import { SearchTag, Suggestion, SuggestionType } from '../types';
import { Suggestion, SuggestionType } from '../types';
// import { SubmitEvent } from '../../types';
// import { getPartnerRevenue } from '../../../tiles/slice/utils';

export const EVENTS_NAME_MAP: Record<SuggestionType, string> = {
  openTab: 'Open tab',
  organic: 'Search autosuggestion',
  organicProvided: 'Submitted term',
  ad: 'Ad',
  url: 'URL returned by search autosuggestion',
  urlCandidate: 'Submitted URL',
  tile: 'Top site or shortcut',
  website: 'Popular website',
  history: 'Website from history',
  historyOrganic: 'Search history',
  instantResult: 'Instant search result',
  instantResultAd: 'Instant ad search result',
  searchTag: 'Search tag',
  placeholder: 'Placeholder',
};

// const getSuggestionType = (suggestion) => {
//   if (!suggestion) return null;
//   return suggestion.type === 'organic' && suggestion.provider
//     ? 'ad'
//     : suggestion.type;
// };

// export const trackSubmit = async (
//   event: SubmitEvent,
//   suggestion: Suggestion,
//   engine: string,
//   gain: number,
//   gainType: string,
//   instantResultsCounter: number,
//   choosenSearchTag: SearchTag
// ): Promise<void> => {
// const type = getSuggestionType(suggestion);

// const events: {
//   variant: 'event' | 'revenue';
//   payload: [string, Record<string, string | number>];
// }[] = [
//     {
//       variant: 'event',
//       payload: [
//         'Search_from_ntp',
//         {
//           category: 'Search',
//           search_engine: engine,
//           search_type: EVENTS_NAME_MAP[type] || type || 'No suggestion',
//           search_tag: choosenSearchTag?.s,
//           shells_value: gainType === 'various' ? gain : 0,
//           event_type: event.type,
//           instant_searches: instantResultsCounter,
//           provider: suggestion?.provider,
//         },
//       ],
//     },
//     {
//       variant: 'event',
//       payload: [
//         'V2_Search',
//         {
//           query: suggestion?.term || '',
//           page: 1,
//           searchType: 'web',
//           platform:
//             process.env.APP_TYPE === 'search' ||
//               process.env.APP_PLATFORM === 'web'
//               ? 'omnibox'
//               : 'ntp',
//           source: 'NTP_Search_Bar',
//         },
//       ],
//     },
//   ];

// if (suggestion && suggestion.type === 'ad') {
//   events.push({
//     variant: 'event',
//     payload: [
//       'Clicked_on_a_cps_ad_in_ntp_search_box',
//       {
//         category: 'Ads',
//         search_engine: engine,
//         // revenue: 0.5,
//         revenue: suggestion.revenue,
//         shells_value: gain,
//       },
//     ],
//   });
//   events.push({
//     variant: 'revenue',
//     payload: [
//       null,
//       {
//         productId: 'NTP_CSP',
//         category: 'Ads',
//         quantity: 1,
//         // price: 0.5,
//         revenue: suggestion.revenue,
//       },
//     ],
//   });

//   events.push({
//     variant: 'event',
//     payload: [
//       'V2_Ad_Click',
//       {
//         platform:
//           process.env.APP_TYPE === 'search' ||
//             process.env.APP_PLATFORM === 'web'
//             ? 'omnibox'
//             : 'ntp',
//         source: 'Search_Suggestion',
//         provider: suggestion.provider,
//         id: `search_suggestion_${suggestion.provider}`,
//         revenue: await getPartnerRevenue(suggestion.provider),
//       },
//     ],
//   });

//   events.push({
//     variant: 'revenue',
//     payload: [
//       null,
//       {
//         productId: `v2_search_suggestion_${suggestion.provider}`,
//         category: 'Ads',
//         quantity: 1,
//         revenue: await getPartnerRevenue(suggestion.provider),
//         platform:
//           process.env.APP_TYPE === 'search' ||
//             process.env.APP_PLATFORM === 'web'
//             ? 'omnibox'
//             : 'ntp',
//       },
//     ],
//   });
// }

// trackOutbound(events);
// };

export const trackSubmit = async (
  suggestion: Suggestion,
  gain: number,
  gainType: string,
): Promise<void> => {
  // Search_from_ntp
  addShells(gainType === 'various' ? gain : 0);

  if (suggestion && suggestion.type === 'ad') {
    // Clicked_on_a_cps_ad_in_ntp_search_box
    addShells(gain);
  }
};